import React from "react";
import styles from "./ComingSoonBadge.module.css";

/**
 * Pastilla dorada animada "Próximamente" (brillo que recorre + pulso suave).
 * Respeta `prefers-reduced-motion` (sin animación).
 *
 * @param {object} props
 * @param {"sm"|"md"|"lg"} [props.size="md"]
 * @param {string} [props.label="Próximamente"]
 * @param {string} [props.className]
 */
export default function ComingSoonBadge({
  size = "md",
  label = "Próximamente",
  className = "",
}) {
  return (
    <span
      className={`${styles.badge} ${styles[size] || ""} ${className}`.trim()}
      role="status"
    >
      <span className={styles.dot} aria-hidden="true" />
      <span className={styles.label}>{label}</span>
      <span className={styles.shine} aria-hidden="true" />
    </span>
  );
}
